// The Focus panel's own lines (`src/panel/`): the notices it shows in place of
// Focus inside an assistant's conversation. No product name: the frame around
// them already says it, and the assistant's name comes from the grant
// (`{assistant}`, "Claude").

import type { MsgSection } from "./types.js";

export const panel: MsgSection = {
  "panel.signedOut.headline": {
    en: "You are signed out here",
    de: "Du bist hier abgemeldet",
  },
  "panel.signedOut.body": {
    en: "The connection behind this panel has ended. Connect again in the assistant’s connector settings, then try again.",
    de: "Die Verbindung hinter diesem Fenster ist beendet. Verbinde dich in den Connector-Einstellungen des Assistenten neu und versuch es dann nochmals.",
  },
  "panel.signedOut.bodyNamed": {
    en: "The connection behind this panel has ended. Connect again in {assistant}’s connector settings, then try again.",
    de: "Die Verbindung hinter diesem Fenster ist beendet. Verbinde dich in den Connector-Einstellungen von {assistant} neu und versuch es dann nochmals.",
  },
  "panel.ticketFailed.headline": {
    en: "Focus could not start here",
    de: "Focus konnte hier nicht starten",
  },
  "panel.ticketFailed.body": {
    en: "This panel could not confirm who you are. Try again in a moment.",
    de: "Dieses Fenster konnte nicht bestätigen, wer du bist. Versuch es gleich nochmals.",
  },
  "panel.pending.headline": {
    en: "Your access is not approved yet",
    de: "Dein Zugang ist noch nicht freigegeben",
  },
  "panel.pending.body": {
    en: "An administrator has to approve your account first. Check again once they have.",
    de: "Eine Administratorin oder ein Administrator muss dein Konto zuerst freigeben. Schau danach nochmals nach.",
  },
  "panel.pending.recheck": { en: "Check again", de: "Nochmals prüfen" },
  "panel.backToStart": { en: "Back to the start", de: "Zurück zum Anfang" },
};
